import Parse from "parse";

export const getApplicationConfig = () => {
    return Parse.Cloud.run("getConfig", {});
}